<template>
  	<div class="njoftime-settings-wrapper">
    	<div>
			<template v-for="(event,index) in event_localy">
				<v-checkbox
					v-if=" index > 1 "
					:key="index"
					color="primary"
					v-model="checkbox[`${event.event_id}`]"
					:label=" index == 2 ? getStateWithParam('show_planned_notifications') : getStateWithParam('show_report_statuses')"
					@change="sendDataChange()"
				></v-checkbox>
			</template>
			<!-- <v-btn class="select-street-btn" color="rgba(0,0,0,0.54);" @click="openCloseSettingsDialog()">
				{{getStateWithParam('notifications_selected_streets')}}
				<v-icon color="red">arrow_drop_down</v-icon>
			</v-btn> -->
			<!-- <v-dialog
				v-model="dialog"
				fullscreen
				hide-overlay
				transition="dialog-bottom-transition"
				scrollable
			>
        		<v-card tile>
					<v-toolbar color="primary" flat dark>
						<v-btn icon dark @click="openCloseSettingsDialog()">
							<v-icon>close</v-icon>
						</v-btn>
						<v-spacer></v-spacer>
						<v-toolbar-items>
							<v-btn flat color="white" text @click="saveStreetRoadsAdClose()">Save</v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-card-text>
						<div v-for="street in street_notification" :key="street.streetName">
							<v-select
								:items="street.segments"
								v-model="seg_model_preinited"
								item-text="segment_name"
								item-value="segment_ids"
								@change="getItemClicked"
								filled
								chip
								:label="street.streetName"
								multiple
							>
								<template v-slot:selection="{ item, index }">
									<v-chip>{{item.segment_name}}</v-chip>
								</template>
							</v-select>
						</div>
					</v-card-text>
        		</v-card>
      		</v-dialog> -->
    	</div>
 	</div>
</template>

<script>
export default {
  	name: "NjoftimeSettingsComponent",
	props: {
		events_selection: {
			type: [Array, Object],
			default: () => [
				{ event_title: "when_traffiv_over_90", active: true },
				{ event_title: "when_streen_blocked", active: true },
				{
				event_title: "show_planned_notifications",
				active: true
				},
				{ event_title: "show_report_statuses", active: true }
			]
		},
		street_notification: {
			type: [Array]
		}
	},
	data() {
		return {
			checkbox: {
				1: true,
				2: true,
				3: true,
				4: true
			},
			seg_model_preinited: [],
			combo_box_name_selector: [],
			event_localy: this.events_selection,
			dialog: false,
			seleced_streets_comma_sep: ""
		};
	},
	mounted() {
		this.change();
		this.preinitChips();
		this.fillRoadsSelected();
	},
  	methods: {
		preinitChips() {
		this.street_notification != undefined
			? this.street_notification.forEach(el => {
				el.segments.forEach(seg => {
					if (seg.isSelected) {
						this.seg_model_preinited.push(seg);
						this.combo_box_name_selector.push(seg.segment_ids);
					}
				});
			})
			: null;
		},
		openCloseSettingsDialog() {
			this.dialog = !this.dialog;
			this.$store.commit("setDialogActivity", this.dialog);
		},
		getSegmentItems(street) {
			return street.segments.map(el => {
				return el.segment_name;
			});
		},
		change() {
			this.events_selection != undefined
				? this.events_selection.map(el => {
					this.checkbox[el.event_id] = el.active;
				})
				: null;
		},
		saveStreetRoadsAdClose() {
			this.openCloseSettingsDialog();
			this.fillRoadsSelected();
		},
		fillRoadsSelected() {
			this.seleced_streets_comma_sep = "";
			this.combo_box_name_selector.map((el, index) => {
				if (this.combo_box_name_selector.length - 1 == index) {
					this.seleced_streets_comma_sep += el;
				} else {
					this.seleced_streets_comma_sep += el + ",";
				}
			});
			this.$emit("savedStreet", this.seleced_streets_comma_sep);
		},
		sendDataChange() {
			for (var key in this.checkbox) {
				this.event_localy[key - 1].active = this.checkbox[key];
			}
			this.$emit("changeNotification", this.event_localy);
		},
		getEventTitle(event_title) {
			return event_title.split("-")[0];
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getItemClicked(item) {
			this.combo_box_name_selector = item;
		}
  	}
};
</script>

<style lang="scss">
.njoftime-settings-wrapper {
	padding: 16px;
	padding-top: 0px;
	.v-input--selection-controls {
		margin-top: 0px !important;
		padding-bottom: 5px;
		&:last-child {
			padding-bottom: 0px;
		}
		.v-input__control {
			width: 100%;
			.v-input__slot {
				display: flex;
				flex-direction: row-reverse;
				justify-content: space-between;
				.v-input--selection-controls__input {
					margin-right: 0px;
				}
			}
		}
	}
}

.select-street-btn {
	padding: 0px !important;
	background-color: transparent !important;
	border: 0 !important;
	box-shadow: none !important;
	text-transform: capitalize;
	width: 100%;
	margin: 0 !important;
	color: rgba(0, 0, 0, 0.54) !important;
	.v-btn__content {
		color: rgba(0, 0, 0, 0.54) !important;
		justify-content: space-between !important;
		font-size: 13px !important;
	}
}
</style>


